import { render, staticRenderFns } from "./MainDrawer.vue?vue&type=template&id=624041ea&scoped=true"
import script from "./mainDrawer.ts?vue&type=script&lang=ts&external"
export * from "./mainDrawer.ts?vue&type=script&lang=ts&external"
import style0 from "./MainDrawer.vue?vue&type=style&index=0&id=624041ea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624041ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('624041ea')) {
      api.createRecord('624041ea', component.options)
    } else {
      api.reload('624041ea', component.options)
    }
    module.hot.accept("./MainDrawer.vue?vue&type=template&id=624041ea&scoped=true", function () {
      api.rerender('624041ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/main-drawer/MainDrawer.vue"
export default component.exports